import React, { useState, useEffect } from "react";
import { createSuplier, updateSupplier } from "../../services/supplier.service";
import { Formik, Form } from "formik";
import CustomField from "../common/customField";
import * as Yup from "yup";
import { useParams } from "react-router-dom";
import BeatLoader from "react-spinners/BeatLoader";
import { optionsForAccountCategory } from "../common/utlity/options";
import { initialValuesForSuppliers } from "../common/utlity/intialValues";
import { toast } from "react-toastify";
import {
  onlyNumber,
  onlyNumberdesimal,
  onlyLetters,
} from "../../helpers/formats";
import CustomPhoneNumberField from "../common/customPhone";
import { Country, State } from "country-state-city";
import { useTranslation } from "react-i18next";
import { FiUser,FiArrowLeft} from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import { AiFillAccountBook } from "react-icons/ai";

const AddSupplier = ({
  close,
  item,
  updateSupplierItem,
  addSupplier,
  businessUuid,
}) => {
  const [countries, setCountries] = useState([]);
  const { t } = useTranslation();
  const [states, setStates] = useState([]);
  const { bussinessUuid: paramUuid } = useParams();
  const finalBusinessUuid = businessUuid || paramUuid;
  const [supplierIsLoading, setSupplierIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleCountryChange = (setFieldValue, countryIsoCode) => {
    setFieldValue("country", countryIsoCode);
    const stateList = State.getStatesOfCountry(countryIsoCode || "IN").map(
      (state) => ({
        label: state.name,
        value: state.isoCode,
      })
    );
    setStates(stateList);
    setFieldValue("state", "");
  };
  useEffect(() => {
    const countryList = Country.getAllCountries().map((country) => ({
      label: country.name,
      value: country.isoCode,
    }));
    const stateList = State.getStatesOfCountry("IN").map((state) => ({
      label: state.name,
      value: state.isoCode,
    }));
    setStates(stateList);
    setCountries(countryList);
  }, []);
  const validationSchema = Yup.object().shape({
    gstIn: Yup.string().matches(
      /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}[Z]{1}[0-9A-Z]{1}$/,
      "Invalid GST IN"
    ),
    fullName: Yup.string()
      .matches(/^[a-zA-Z\s]+$/, "Name must contain only letters")
      .min(2, "Name must be at least 2 characters")
      .max(50, "Name must be at most 50 characters")
      .required(
        <span className='text-xs dark:text-red-500'>Name is required</span>
      ),
    email: Yup.string().email("Invalid email"),
    // supplierMobile: Yup.string()
    //   .min(10, "Number must be at least 10 digits")
    //   .max(15, "Number must be at most 10 digits"),
    // // .required(<span className='text-xs'>Mobile is required</span>),
    pincode: Yup.string().test(
      "is-valid-pincode",
      "Pincode must be between 5 and 10 digits",
      (value) => !value || /^[0-9]{5,10}$/.test(value)
    ),
    contactPersonName: Yup.string()
      .matches(/^[a-zA-Z\s]+$/, "Name must contain only letters")
      .min(2, "Name must be at least 2 characters")
      .max(50, "Name must be at most 50 characters"),
    // contactPersonPhone: Yup.string().test(
    //   "is-valid-customer_mobile",
    //   "Mobile number must be 10 to 15 digits",
    //   (value) => !value || /^[0-9]{10}$/.test(value)
    // ),
    accountNumber: Yup.string().matches(
      /^[0-9]{5,18}$/,
      "Account number must be between 5 to 18 digits"
    ),
  });

  const onSubmit = async (values, { resetForm }) => {
    if (!finalBusinessUuid) {
      toast.error("Business UUID is missing");
      return;
    }

    const dataForSave = {
      ...values,
      bussinessUuid: finalBusinessUuid,
    };

    try {
      setSupplierIsLoading(true);

      if (item) {
        // Update existing supplier
        const { vendorUuid } = item;
        const result = await updateSupplier(
          finalBusinessUuid,
          vendorUuid,
          dataForSave
        );

        if (result.status === 200) {
          updateSupplierItem(result?.data);
          toast.success("Updated Successfully");
          close(true);
          navigate(-1)
        } else {
          throw new Error("Failed to update supplier");
        }
      } else {
        // Create new supplier
        const result = await createSuplier(finalBusinessUuid, dataForSave);

        if (result.status === 201) {
          addSupplier(result.data);
          toast.success("Created Successfully");
          resetForm();
          close();
          navigate(-1)
        } else {
          throw new Error("Failed to create supplier");
        }
      }
    } catch (error) {
      toast.error(error.message || "Something went wrong!");
      console.error("Error:", error);
    } finally {
      setSupplierIsLoading(false); // Set loading to false when done
    }
  };
  return (
    <Formik
      enableReinitialize={true}
      initialValues={initialValuesForSuppliers(item ? item : null)}
      validationSchema={validationSchema}
      onSubmit={onSubmit}
    >
      {(formik) => {
        const {
          errors,
          values,
          touched,
          handleBlur,
          handleChange,
          setFieldValue,
        } = formik;
        return (
          <Form>
            <div className="bg-white h-screen overflow-hidden dark:bg-slate-900 border border-slate-200/80 dark:border-slate-700 shadow-lg shadow-slate-200/40 dark:shadow-black/20 p-4 transition-all duration-300">
            <button
              type="button"
              onClick={() => navigate(-1)}
              className="flex items-center justify-center w-11 h-11 mb-3 rounded-xl border border-gray-300 dark:border-gray-700 bg-white dark:bg-slate-800 hover:bg-blue-50 dark:hover:bg-slate-700 transition-all shadow-sm"
            >
              <FiArrowLeft className="text-xl text-gray-700 dark:text-white" />
            </button>
              <div className="mt-1 p-4 rounded-xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gradient-to-br dark:from-slate-900 dark:via-indigo-950 dark:to-slate-800 shadow-[0_0_15px_rgba(0,0,0,0.08)] dark:shadow-[0_0_20px_rgba(0,0,0,0.4)]">
                <div className="flex items-center gap-3 mb-3">
                                    <div className=" rounded-full flex items-center justify-center">
                                      <FiUser
                    size={20}
                    className="text-blue-600 dark:text-white"
                  />
                                    </div>
                  
                                    <h2 className="text-1xl font-semibold text-slate-800 dark:text-white">
                                      {t('SIDER.SUPPLIER_DETAILS')}
                                    </h2>
                                  </div>
                <div className='mt-4'>

                      <div className="grid grid-cols-1 mt-2 sm:grid-cols-2 lg:grid-cols-4 gap-4">
                        <div className='mb-3'>
                          <CustomField
                            type='text'
                            name='fullName'
                            placeholder='Full Name'
                            label={t("FORM.NAME")}
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            value={values?.fullName}
                            onKeyPress={onlyLetters}
                            error={errors.fullName}
                            touched={touched.fullName}
                          />
                        </div>

                        <div className='mb-3'>
                          {/* <CustomField
                            type='text'
                            name='supplierMobile'
                            placeholder='Phone'
                            label='Supplier Mobile *'
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            value={values.supplierMobile}
                            error={errors.supplierMobile}
                            touched={touched.supplierMobile}
                            onKeyPress={onlyNumber}
                            maxLength={10}
                          /> */}
                          <CustomPhoneNumberField
                            name='supplierMobile'
                            country={values.countryCode}
                            label={t("FORM.SUPPLIER_NUMBER")}
                            placeholder='Mobile number'
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.supplierMobile}
                            error={errors.supplierMobile}
                            touched={touched.supplierMobile}
                          />
                        </div>
                        <div className='mb-3'>
                          <CustomField
                            type='date'
                            name='buddysinceDate'
                            label={t("FORM.SINCE_DATE")}
                            placeholder='Since Date'
                            handleChange={handleChange}
                            value={values.buddysinceDate}
                          />
                        </div>
                        <div className='mb-3'>
                          <CustomField
                            type='text'
                            name='gstIn'
                            label={t("FORM.GSTIN")}
                            placeholder='Supplier GST'
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            value={values.gstIn}
                            error={errors.gstIn}
                            // touched={touched.gstIn}
                          />
                          {touched.gstIn && errors.gstIn && (
                            <div style={{ color: "red", fontSize: "12px" }}>
                              {errors.gstIn}
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="grid grid-cols-1 mt-2 sm:grid-cols-2 lg:grid-cols-4 gap-4">
                        <div>
                          <CustomField
                            type='select'
                            name='country'
                            label={t("FORM.COUNTRY")}
                            options={countries}
                            setFieldValue={setFieldValue}
                            handleChange={(e) =>
                              handleCountryChange(
                                setFieldValue,
                                e?.target?.value
                              )
                            }
                            value={values.country}
                          />
                        </div>
                        <div>
                          <CustomField
                            type='select'
                            name='state'
                            label={t("FORM.SATAE")}
                            placeholder='State'
                            handleChange={(e) =>
                              setFieldValue("state", e?.target?.value)
                            }
                            options={states}
                            setFieldValue={setFieldValue}
                            value={values.state}
                          />
                        </div>
                        <div>
                          <CustomField
                            type='text'
                            name='address'
                            label={t("FORM.ADDRESS")}
                            placeholder='Address'
                            handleChange={handleChange}
                            value={values.address}
                            handleBlur={handleBlur}
                            helperText={
                              <span className='text-gray-600 dark:text-white'>
                                Use Space only
                              </span>
                            }
                          />
                        </div>
                        <div>
                          <CustomField
                            type='text'
                            name='pincode'
                            placeholder='Pincode'
                            label={t("SIDER.PINCODE")}
                            handleChange={handleChange}
                            value={values.pincode}
                            handleBlur={handleBlur}
                            error={errors.pincode}
                            touched={touched.pincode}
                            onKeyPress={onlyNumber}
                            maxLength={10}
                          />
                        </div>
                      </div>
                      <div className="grid grid-cols-1 mt-2 sm:grid-cols-2 lg:grid-cols-4 gap-4">
                        <div>
                          <CustomField
                            type='text'
                            name='email'
                            placeholder='Email'
                            label={t("SIDER.EMAIL")}
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            value={values.email}
                            error={errors.email}
                            touched={touched.email}
                          />
                        </div>
                        <div>
                          <CustomField
                            type='text'
                            name='description'
                            label={t("SIDER.DESCRIPTION")}
                            placeholder='Description'
                            handleChange={handleChange}
                            value={values.description}
                          />
                        </div>

                        <div>
                          <CustomField
                            type='text'
                            name='contactPersonName'
                            label={t("SIDER.CONTACT_PERSON_NAME")}
                            placeholder='Contact Person Name'
                            handleChange={handleChange}
                            value={values.contactPersonName}
                            onKeyPress={onlyLetters}
                          />
                        </div>
                        <div>
                          <CustomPhoneNumberField
                            country={values.countryCode}
                            label={t("SIDER.CONTACT_PERSON_PHONE")}
                            name='contactPersonPhone'
                            placeholder='Contact Person Phone'
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.contactPersonPhone}
                            // error={errors.contactPersonPhone}
                            // touched={touched.contactPersonPhone}
                          />
                        </div>
                      </div>
                     <div className="grid grid-cols-1 mt-6 sm:grid-cols-2 lg:grid-cols-4 gap-4">
                        <div>
                          <CustomField
                            type='text'
                            name='totalPurchase'
                            label={t("SIDER.TOTAL_PURCHASE")}
                            placeholder='Total Amount'
                            handleChange={(e) => {
                              setFieldValue("totalPurchase", e.target.value);
                              setFieldValue(
                                "pendingAmount",
                                parseFloat(e.target.value || 0) -
                                  parseFloat(values.paidAmount || 0)
                              );
                            }}
                            value={values.totalPurchase}
                            onKeyPress={onlyNumberdesimal}
                          />
                        </div>
                        <div>
                          <CustomField
                            type='text'
                            name='paidAmount'
                            label={t("SIDER.PAID_AMOUNT")}
                            placeholder='Paid Amount'
                            handleChange={(e) => {
                              setFieldValue("paidAmount", e.target.value);
                              setFieldValue(
                                "pendingAmount",
                                parseFloat(values.totalPurchase || 0) -
                                  parseFloat(e.target.value || 0)
                              );
                            }}
                            value={values.paidAmount}
                            onKeyPress={onlyNumberdesimal}
                          />
                        </div>
                        <div>
                          <CustomField
                            type='text'
                            name='pendingAmount'
                            label={t("SIDER.PENDING_AMOUNT")}
                            placeholder='Pending Amount'
                            // handleChange={handleChange}
                            value={values.pendingAmount || 0}
                            // onKeyPress={onlyNumberdesimal}
                            readOnly
                          />
                        </div>
                        <div>
                          <CustomField
                            type='text'
                            name='pan'
                            label={t("PROFILE.BUSINESS_PAN")}
                            placeholder='pan'
                            handleChange={handleChange}
                            value={values.pan}
                          />
                        </div>
                        <div>
                          <CustomField
                            type='text'
                            name='advanceamount'
                            label='Advance Amount'
                            placeholder='Advance Amount'
                            handleChange={handleChange}
                            value={values.advanceamount}
                            disabled={parseFloat(values.pendingAmount) > 0}
                          />
                        </div>
                      </div>
                </div>
              </div>
                    <div className="mt-3 p-4 rounded-xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gradient-to-br dark:from-slate-900 dark:via-indigo-950 dark:to-slate-800 shadow-[0_0_15px_rgba(0,0,0,0.08)] dark:shadow-[0_0_20px_rgba(0,0,0,0.4)]">
                      <div className="flex items-center gap-3 mb-3">
                                    <div className=" rounded-full flex items-center justify-center">
                                      <AiFillAccountBook
                    size={20}
                    className="text-blue-600 dark:text-white"
                  />
                                    </div>
                  
                                    <h2 className="text-1xl font-semibold text-slate-800 dark:text-white">
                                      {t('SIDER.ACCOUNT_DETAILS')}
                                    </h2>
                                  </div>
                      <div className='grid grid-cols-3 gap-4'>
                        <div className='p-1'>
                          <CustomField
                            type='text'
                            name='accountNumber'
                            label={t("SIDER.ACCOUNT_NUMBER")}
                            placeholder='Account Number'
                            handleChange={handleChange}
                            value={values.accountNumber}
                            handleBlur={handleBlur}
                            error={errors.accountNumber}
                            touched={touched.accountNumber}
                            onKeyPress={onlyNumber}
                          />
                        </div>
                        <div className='p-1'>
                          <CustomField
                            type='text'
                            name='ifscNumber'
                            label={t("PROFILE.BUSINESS_IFSC")}
                            placeholder='IFSC Number'
                            handleChange={handleChange}
                            value={values.ifscNumber}
                            maxLength={11}
                          />
                        </div>
                        <div className='p-1'>
                          <CustomField
                            type='select'
                            name='accountType'
                            label={t("SIDER.ACCOUNT_TYPE")}
                            placeholder='Account Type'
                            handleChange={handleChange}
                            value={values.accountType}
                            options={optionsForAccountCategory}
                            setFieldValue={setFieldValue}
                          />
                        </div>
                      </div>
                    </div>
              <div className='flex  flex justify-end mt-4'>
                {item ? (
                  <button
                    type='submit'
                    className='w-1/2 py-2 px-2 bg-blue-600 hover:bg-blue-700 text-white  mt-4 font-bold rounded justify-content-right'
                    disabled={supplierIsLoading}
                  >
                    <span> {t("FORM.UPDATE_SUPPLIER")}</span>
                    {supplierIsLoading && (
                      <span className='ml-2'>
                        <BeatLoader
                          color='#5556d3'
                          loading={supplierIsLoading}
                          size={8}
                        />
                      </span>
                    )}
                  </button>
                ) : (
                  <button
                    type='submit'
                    className='w-1/2 py-2 px-2 bg-blue-600 hover:bg-blue-700 text-white  mt-4 font-bold rounded justify-content-right'
                    disabled={supplierIsLoading}
                  >
                    {supplierIsLoading ? (
                      <BeatLoader
                        size={8}
                        color='#ffffff'
                        loading={supplierIsLoading}
                      />
                    ) : (
                      t("FORM.ADD_SUPPLIER")
                    )}
                  </button>
                )}
              </div>
            </div>
          </Form>
        );
      }}
    </Formik>
  );
};

export default AddSupplier;
